import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Awards from "../components/Awards";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Gallery from "../components/Gallery";
import GoogleReviews from "../components/GoogleReviews";
import CTABanner from "../components/CTABanner";
import Footer from "../components/Footer";
import AdSlots from "../components/AdSlots";
import QuoteFormDialog from "../components/QuoteFormDialog";

const Landing = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [catalogGroup, setCatalogGroup] = useState('');
  const openQuote = (group = '') => { setCatalogGroup(typeof group === 'string' ? group : ''); setQuoteOpen(true); };

  return (
    <div data-testid="landing-page" className="bg-[#09090b] min-h-screen">
      <Navbar onQuoteClick={openQuote} />
      <Hero onQuoteClick={openQuote} />
      <Services onQuoteClick={openQuote} />
      <Awards />
      <WhyChooseUs />
      <Gallery />
      <GoogleReviews />
      <CTABanner onQuoteClick={openQuote} />
      <AdSlots />
      <Footer />
      <QuoteFormDialog key={catalogGroup} initialServiceGroup={catalogGroup} open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
};

export default Landing;
